"use client";
import React from 'react';
import { ProductProvider } from './Productcontext';
import Installation from './Installation';
import DesignCommissionContent from './DesignCommissionContent';
import ScrollToTopButton from './ScrollToTopButton';
import Footer from './Footer';

// Shared page body for every /ourservices/<service> route.
// `active` is the current service slug; it drives which panel + menu item is active.
export default function ServicesShell({ active }) {
  const displline = true;
  return (
    <div>
      <ProductProvider>
        <div id="install">
          <Installation active={active} />
        </div>
        <div id="design">
          <DesignCommissionContent />
        </div>
        <ScrollToTopButton />
        <Footer linedisp={displline} />
      </ProductProvider>
    </div>
  );
}
